import React from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from 'react-lazy-load-image-component';


function DetailsSection(props) {

  return (
    <section>
        {
          props.content.map((item, sectionIndex) => (
            <div className={item.lastItem === true ? "portfolio-border-bottom" : ""} key={`section-${sectionIndex}`}>
              <div className="text-section-padd">
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-md-7">
                        <h2>{item.detailsTitle}</h2>

                        {
                          item.paragraphList.map((itemL, paraIndex) => (
                            <React.Fragment key={`para-${sectionIndex}-${paraIndex}`}>
                              <h6>{itemL.subTitle}</h6>

                              <p className="problem-statement-para">{itemL.problemStatement}</p>

                              {
                                itemL.subText.map((itemSubText, subIndex) => (
                                  <p className="main-text-para" key={`subtext-${sectionIndex}-${paraIndex}-${subIndex}`}>{itemSubText.stItem}</p>
                                ))
                              }
                            </React.Fragment>
                          ))
                        }
                    </div>
                    {/* <div className="col-12 col-md-1"></div> */}
                    {/* <div className="col-12 col-md-3"> */}
                      {
                        item.role === null ? (
                          <>
                            <div className="col-12 col-md-1"></div>
                            <div className="col-12 col-md-4 pt-5">
                              {/* <img src={item.roleImg} alt="" /> */}

                              <LazyLoadImage
                                alt=""
                                src={item.roleImg} />
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="col-12 col-md-2"></div>
                            <div className="col-12 col-md-3">
                              <h5>My Role</h5>

                              <hr />

                              {
                                item.role.map((itemR, roleIndex) => (
                                  <p className="main-text-para" key={`detail-role-${sectionIndex}-${roleIndex}`}>{`- ${itemR.rolItem}`}</p>
                                ))
                              }
                            </div>
                          </>
                        )
                      }
                    {/* </div> */}
                  </div>

                  {
                    item.breakdownSegment === true ? (

                      <div className="row mt-5 pt-5">
                        <div className="col-12">
                          <h5 style={{ marginBottom: -20 }}>{item.breakdownMainTitle}</h5>
                        </div>
                        {
                          item.breakdownSegmentItems.map((itemB, breakIndex) => (
                            <div className="col-12 col-md-3" key={`breakdown-${sectionIndex}-${breakIndex}`}>
                              <div className="breakdown-segment-div">
                                <div className="breakdown-segment-img mb-4">
                                  {/* <img src={itemB.breakdownImg} alt="" /> */}

                                  <LazyLoadImage
                                    alt={`${itemB.breakdownTitle} illustration`}
                                    src={itemB.breakdownImg} />
                                </div>
                                <div className="breakdown-segment-title mb-3">
                                  <h4>{itemB.breakdownTitle}</h4>
                                </div>
                                <div className="breakdown-segment-text">
                                  <p>{itemB.breakdownText}</p>
                                </div>
                              </div>
                            </div>
                          ))
                        }
                      </div>
                    ) : (
                      null
                    )
                  }
                </div>

                {
                  item.detailsFullSegmentImage === true ? (
                    <div className="container-fluid">
                      <div className="row portfolio-image-div">
                        <div className="col-12 col-md-12 reset-padding">
                          {/* <img src={item.detailsSectionImage} alt="" /> */}

                          <LazyLoadImage
                            alt={`${item.detailsTitle} full width showcase`}
                            src={item.detailsSectionImage} />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="container">
                      <div className="row portfolio-image-div mb-5">
                        {
                          item.detailsImages.map((itemDI, imgIndex) => (
                            <div className="col-12 col-md-4" key={`detail-img-${sectionIndex}-${imgIndex}`}>
                              {/* <img src={itemDI} alt="" /> */}

                              <LazyLoadImage
                                alt={`${item.detailsTitle} screenshot ${imgIndex + 1}`}
                                className="app-image-deco mb-5"
                                src={itemDI} />
                            </div>
                          ))
                        }
                      </div>
                    </div>
                  )
                }
                
                <div className="container">
                  <div className="separator-hr-div">
                    {item.lastItem === true ? (null) : (item.detailsFullSegmentImage === true ? (null) : (<hr />))}
                  </div>
                </div>
              </div>
            </div>
          ))
        }
    </section>
  )
}

DetailsSection.propTypes = {
  content: PropTypes.arrayOf(PropTypes.shape({
    detailsTitle: PropTypes.string.isRequired,
    paragraphList: PropTypes.arrayOf(PropTypes.shape({
      subTitle: PropTypes.string,
      problemStatement: PropTypes.string,
      subText: PropTypes.arrayOf(PropTypes.shape({
        stItem: PropTypes.string
      }))
    })),
    role: PropTypes.arrayOf(PropTypes.shape({
      rolItem: PropTypes.string
    })),
    detailsFullSegmentImage: PropTypes.bool,
    detailsSectionImage: PropTypes.string,
    detailsImages: PropTypes.arrayOf(PropTypes.string),
    lastItem: PropTypes.bool,
    breakdownSegment: PropTypes.bool,
    breakdownMainTitle: PropTypes.string,
    breakdownSegmentItems: PropTypes.arrayOf(PropTypes.shape({
      breakdownImg: PropTypes.string,
      breakdownTitle: PropTypes.string,
      breakdownText: PropTypes.string
    }))
  })).isRequired
};

export default DetailsSection;
